import React, { useContext, useEffect } from 'react';
import { Box, Card, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import ManualMetrics from './ManualMetrics';
import DtbMetrics from './DtbMetrics';
import PolicySolutions from './PolicySolutions';
import Assignments from './Assignments';
import CommonLayout from '../../_layouts/CommonLayout';
import { AppContext } from 'views/App/context';
import { Alert, Typography } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';
import { useDashboard } from '../context';

export default function PolicyDashboard() {
  const {
    currentOrganizationId,
    hasNoPermission,
    hasAppPermission,
    hasPermission,
    hasPermissionError,
  } = useContext(AppContext);
  const { tabs } = useDashboard();

  const DashboardContent = () => {
    if (hasPermissionError) {
      return (
        <Alert
          severity='error'
          sx={{ mb: 2 }}
        >
          <Typography variant='body1'>
            Lexipol has encountered a problem retrieving your data, please contact Customer Support.
          </Typography>
        </Alert>
      );
    }

    if (hasNoPermission() && !hasPermissionError) {
      return (
        <Alert severity='warning'>
          <Typography variant='body1'>{t('dashboard.noPermissions')}</Typography>
        </Alert>
      );
    }

    if (!hasAppPermission('listDraftManuals') && !hasAppPermission('listIssuedManuals')) {
      return null;
    }

    const showDtbMetrics = hasPermission('listDtbPackages', currentOrganizationId);

    return (
      <Box
        className='policy-dashboard'
        sx={{
          display: 'grid',
          gridTemplateColumns: '3fr 1fr',
          gap: 10,
        }}
      >
        <Stack spacing={8}>
          <ManualMetrics />
          {showDtbMetrics && <DtbMetrics />}
          <Assignments />
        </Stack>
        <Stack spacing={8}>
          <PolicySolutions />
        </Stack>
      </Box>
    );
  };

  return (
    <CommonLayout
      noPadding
      tabs={tabs}
    >
      <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }}>
        <DashboardContent />
      </Box>
    </CommonLayout>
  );
}
